export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";